import {Dispatch, FC, SetStateAction} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../../_metronic/helpers'
import {Button, ButtonWrapper} from '../../../../../components/UI/Button'
interface DetailTicket {
  nroBoleta: string
  fechaSalida: string
  nroOrdenLavado: string
  servicioLavado: string
  site: string
  campamento: string
  responsable: string
  estatusHuesped: string
  huespedId: string
  huesped: string
  tipoEmpresa: string
  modulo: string
  habitacion: string
  cama: string
  lugarLavado: string
  cantidadTotal: string
  pesoTotal: string
  fechaRecepcion: string
  fechaEntrega: string
  observaciones: string
  estadoOrdenLavado: string
  colaboradorId: string
  colaborador: string
  empresa: string
  telefono: string
  email: string
}

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  idPermission?: ''
  data?: DetailTicket
  nameTitle?: string
  userTicket?: string
  funcSendEmail?: () => void
  funcSeePDF?: () => void
  funcSeeDetailPrint?: () => void
  typeTab?: string
}
interface PropsForm {
  data?: DetailTicket | any
  typeTab?: string
}
const FormColaborator: FC<PropsForm> = ({data, typeTab}) => {
  return (
    <div className='row'>
      <div className='col-6'>
        <div className='row'>
          <div className='col-6 pb-2 sdx-gray-200-bg'>
            <strong>Nro. Boleta</strong>
          </div>
          <div className='col-6 d-flex justify-content-end pb-2 sdx-gray-200-bg '>
            {data.nroBoleta}
          </div>
          <div className='col-6 d-flex pb-2 sdx-gray-200-bg'>
            <strong>Fecha y hora de impresión</strong>
          </div>
          <div className='col-6 d-flex justify-content-end pb-2 sdx-gray-200-bg'>
            {data.fechaSalida}
          </div>
          <div className='col-6 d-flex pb-2 sdx-gray-200-bg'>
            <strong>Nro. de Orden de Lavado</strong>
          </div>
          <div className='col-6 d-flex justify-content-end pb-1 sdx-gray-200-bg'>
            {data.nroOrdenLavado}
          </div>
          <div className='col-6 pb-4 mt-2'>
            <strong>Servicio de Lavado</strong>
          </div>
          <div className='col-6 mt-2'>{data.servicioLavado}</div>
          <div className='col-6 pb-2'>
            <strong>Site</strong>
          </div>
          <div className='col-6 pb-2'>{data.site}</div>
          <div className='col-6 pb-2'>
            <strong>Campamento</strong>
          </div>
          <div className='col-6 pb-2'>{data.campamento}</div>
          <div className='col-6 pb-2'>
            <strong>Responsable</strong>
          </div>
          <div className='col-6 pb-2'>{data.responsable}</div>
          <div className='col-6 pb-2'>
            <strong>Estatus huésped</strong>
          </div>
          <div className='col-6 pb-2'>{data.estatusHuesped}</div>
          <div className='col-6 pb-2'>
            <strong>Huésped</strong>
          </div>
          <div className='col-6 pb-2'>{data.huesped}</div>
          <div className='col-6 pb-2'>
            <strong>Tipo Empresa</strong>
          </div>
          <div className='col-6 pb-2'>{data.tipoEmpresa}</div>
          <div className='col-6 pb-2'>
            <strong>Módulo</strong>
          </div>
          <div className='col-6 pb-2'>{data.modulo}</div>
          <div className='col-6 pb-2'>
            <strong>Habitación</strong>
          </div>
          <div className='col-6 pb-2'>{data.habitacion}</div>
          <div className='col-6 pb-2'>
            <strong>Cama</strong>
          </div>
          <div className='col-6 pb-2'>{data.cama}</div>
        </div>
      </div>
      <div className='col-6'>
        <div className='row'>
          <div className='col-6 pb-2'>
            <strong>Lugar de Lavado</strong>
          </div>
          <div className='col-6 pb-2'>{data.lugarLavado}</div>
          <div className='col-6 pb-2'>
            <strong>Cantidad total de prendas</strong>
          </div>
          <div className='col-6 pb-2 d-flex justify-content-end'>{data.cantidadTotal}</div>
          <div className='col-6 pb-2'>
            <strong>Peso total de prendas</strong>
          </div>
          <div className='col-6 pb-2 d-flex justify-content-end'>{data.pesoTotal} kg</div>
          {typeTab === 'reception' && (
            <div className='col-6 pb-2'>
              <strong>Fecha de recepción</strong>
            </div>
          )}
          {typeTab === 'reception' && (
            <div className='col-6 pb-2 d-flex justify-content-end'>{data.fechaRecepcion}</div>
          )}
          {typeTab === 'reception' && (
            <div className='col-6 pb-2'>
              <strong>Fecha de entrega programada</strong>
            </div>
          )}
          {typeTab === 'reception' && (
            <div className='col-6 pb-2 d-flex justify-content-end'>{data.fechaEntrega}</div>
          )}
          {typeTab !== 'reception' && (
            <div className='col-6 pb-2'>
              <strong>Fecha de salida</strong>
            </div>
          )}
          {typeTab !== 'reception' && (
            <div className='col-6 pb-2 d-flex justify-content-end'>{data.fechaSalida}</div>
          )}
          <div className='col-6 pb-2'>
            <strong>Bolsa</strong>
          </div>
          <div className='col-6 pb-2 d-flex justify-content-end'>{data.bolsaCorrelativo}</div>
          <div className='col-6 pb-2'>
            <strong>Rotulado</strong>
          </div>
          <div className='col-6 pb-2 d-flex justify-content-end'>{data.rotuladoCorrelativo}</div>
          <div className='col-6 pb-2'>
            <strong>Observaciones</strong>
          </div>
          <div className='col-6 pb-2 d-flex justify-content-end'>{data.observaciones}</div>
          <div className='col-6 pb-2'>
            <strong>Estado de la orden de lavado</strong>
          </div>
          <div className='col-6 pb-2 d-flex justify-content-end'>{data.estadoOrdenLavado}</div>
        </div>
      </div>
    </div>
  )
}
const FormHuesped: FC<PropsForm> = ({data, typeTab}) => {
  return (
    <div className='row'>
      <div className='col-6'>
        <div className='row'>
          <div className='col-6 pb-2 sdx-gray-200-bg'>
            <strong>Nro. Boleta</strong>
          </div>
          <div className='col-6 d-flex justify-content-end pb-2 sdx-gray-200-bg '>
            {data.nroBoleta}
          </div>
          <div className='col-6 d-flex pb-2 sdx-gray-200-bg'>
            <strong>Fecha y hora de impresión</strong>
          </div>
          <div className='col-6 d-flex justify-content-end pb-2 sdx-gray-200-bg'>
            {data.fechaSalida}
          </div>
          <div className='col-6 d-flex pb-2 sdx-gray-200-bg'>
            <strong>Nro. de Orden de Lavado</strong>
          </div>
          <div className='col-6 d-flex justify-content-end pb-1 sdx-gray-200-bg'>
            {data.nroOrdenLavado}
          </div>
          <div className='col-6 pb-4 mt-2'>
            <strong>Servicio de Lavado</strong>
          </div>
          <div className='col-6 mt-2'>{data.servicioLavado}</div>
          <div className='col-6 pb-2'>
            <strong>Site</strong>
          </div>
          <div className='col-6 pb-2'>{data.site}</div>
          <div className='col-6 pb-2'>
            <strong>Campamento</strong>
          </div>
          <div className='col-6 pb-2'>{data.campamento}</div>
          <div className='col-6 pb-2'>
            <strong>Responsable</strong>
          </div>
          <div className='col-6 pb-2'>{data.responsable}</div>
          <div className='col-6 pb-2'>
            <strong>Estatus huésped</strong>
          </div>
          <div className='col-6 pb-2'>{data.estatusHuesped}</div>
          <div className='col-6 pb-2'>
            <strong>Huésped</strong>
          </div>
          <div className='col-6 pb-2'>{data.huesped}</div>
          <div className='col-6 pb-2'>
            <strong>Tipo Empresa</strong>
          </div>
          <div className='col-6 pb-2'>{data.tipoEmpresa}</div>
          <div className='col-6 pb-2'>
            <strong>Módulo</strong>
          </div>
          <div className='col-6 pb-2'>{data.modulo}</div>
          <div className='col-6 pb-2'>
            <strong>Habitación</strong>
          </div>
          <div className='col-6 pb-2'>{data.habitacion}</div>
          <div className='col-6 pb-2'>
            <strong>Cama</strong>
          </div>
          <div className='col-6 pb-2'>{data.cama}</div>
        </div>
      </div>
      <div className='col-6'>
        <div className='row'>
          <div className='col-6 pb-2'>
            <strong>Lugar de Lavado</strong>
          </div>
          <div className='col-6 pb-2'>{data.lugarLavado}</div>
          <div className='col-6 pb-2'>
            <strong>Cantidad total de prendas</strong>
          </div>
          <div className='col-6 pb-2 d-flex justify-content-end'>{data.cantidadTotal}</div>
          <div className='col-6 pb-2'>
            <strong>Peso total de prendas</strong>
          </div>
          <div className='col-6 pb-2 d-flex justify-content-end'>{data.pesoTotal} kg</div>
          {typeTab === 'reception' && (
            <div className='col-6 pb-2'>
              <strong>Fecha de recepción</strong>
            </div>
          )}
          {typeTab === 'reception' && (
            <div className='col-6 pb-2 d-flex justify-content-end'>{data.fechaRecepcion}</div>
          )}
          {typeTab === 'reception' && (
            <div className='col-6 pb-2'>
              <strong>Fecha de entrega programada</strong>
            </div>
          )}
          {typeTab === 'reception' && (
            <div className='col-6 pb-2 d-flex justify-content-end'>{data.fechaEntrega}</div>
          )}
          {typeTab !== 'reception' && (
            <div className='col-6 pb-2'>
              <strong>Fecha de salida</strong>
            </div>
          )}
          {typeTab !== 'reception' && (
            <div className='col-6 pb-2 d-flex justify-content-end'>{data.fechaSalida}</div>
          )}
          <div className='col-6 pb-2'>
            <strong>Bolsa</strong>
          </div>
          <div className='col-6 pb-2 d-flex justify-content-end'>{data.bolsaCorrelativo}</div>
          <div className='col-6 pb-2'>
            <strong>Rotulado</strong>
          </div>
          <div className='col-6 pb-2 d-flex justify-content-end'>{data.rotuladoCorrelativo}</div>
          <div className='col-6 pb-2'>
            <strong>Observaciones</strong>
          </div>
          <div className='col-6 pb-2 d-flex justify-content-end'>{data.observaciones}</div>
          <div className='col-6 pb-2'>
            <strong>Estado de la orden de lavado</strong>
          </div>
          <div className='col-6 pb-2 d-flex justify-content-end'>{data.estadoOrdenLavado}</div>
        </div>
      </div>
    </div>
  )
}
const ModalTicket: FC<Props> = ({
  show,
  setShow,
  idPermission,
  data,
  nameTitle,
  userTicket,
  typeTab,
  funcSendEmail = null,
  funcSeePDF = null,
  funcSeeDetailPrint = null,
}) => {
  const handleClose = () => {
    setShow(false)
  }
  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          {idPermission ? (
            <h5 className='modal-title'>Imprimir boleta de {nameTitle}</h5>
          ) : (
            <h5 className='modal-title'>Re-impresión boleta de {nameTitle}</h5>
          )}

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body pt-2'>
          <ButtonWrapper className='sdx-white-bg'>
            {funcSendEmail && <Button label='Enviar correo' onClick={funcSendEmail} />}
            {funcSeePDF && <Button label='Ver PDF' onClick={funcSeePDF} />}
            {funcSeeDetailPrint && (
              <Button label='Ver boleta detallada' onClick={funcSeeDetailPrint} />
            )}
          </ButtonWrapper>
          <hr className='divider' />
          <div className='px-5 py-2'>
            {data && Object.values(data).length > 0 && (
              <>
                {userTicket === 'colaborator' && <FormColaborator data={data} typeTab={typeTab} />}
                {userTicket === 'huesped' && <FormHuesped data={data} typeTab={typeTab} />}
              </>
            )}
          </div>
        </div>
      </div>
    </Modal>
  )
}

export {ModalTicket}
